import { render } from "./WorkerTasksByUserChart.vue?vue&type=template&id=35311507&scoped=true"
import script from "./WorkerTasksByUserChart.vue?vue&type=script&lang=js"
export * from "./WorkerTasksByUserChart.vue?vue&type=script&lang=js"

import "./WorkerTasksByUserChart.vue?vue&type=style&index=0&id=35311507&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/RACINGBIKE/mi-stock-alavision-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35311507"]])

export default __exports__